(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
if (window.innerWidth > 960) {
window.onscroll = function () {
  scrollRotate();
};
}

function scrollRotate() {
  let image = document.getElementById("image1");
  let image2 = document.getElementById("image2");
  let image3 = document.getElementById("image3");
  let image4 = document.getElementById("image4");
  let image5 = document.getElementById("image5");
  let image6 = document.getElementById("image6");
  image.style.transform = "rotate(" + window.pageYOffset/200 + "deg) translateY(" + window.pageYOffset*2/20 + "px)";
  image2.style.transform = "rotate(" + window.pageYOffset/200 + "deg) translateY(" + window.pageYOffset*2/30 + "px)";
  image3.style.transform = "rotate(" + window.pageYOffset/-100 + "deg) translateY(" + window.pageYOffset*2/60 + "px)";
  image4.style.transform = "rotate(" + window.pageYOffset/-150 + "deg) translateY(" + window.pageYOffset*2/20 + "px)";
  image5.style.transform = "rotate(" + window.pageYOffset/-200 + "deg) translateY(" + window.pageYOffset*2/20 + "px)";
  image6.style.transform = "rotate(" + window.pageYOffset/100 + "deg) translateY(" + window.pageYOffset*2/50 + "px)";
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
$('.footer-block').click(function() {
  $(this).find('.footer-block__details-content').toggleClass('open');
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");

  items.forEach(item => {
    item.style.textDecorationColor  = "transparent";
    item.addEventListener("mouseover", () => {
      item.style.textDecorationColor  = "black";
      item.setAttribute("open", true);
      item.querySelector(".mega-menu__content").addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        item.style.textDecorationColor  = "black";
      });

      item.querySelector(".mega-menu__content").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        item.style.textDecorationColor  = "transparent";
      });

  });
  item.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
    item.style.textDecorationColor  = "transparent";
  });
  });
  customElements.define('sticky-header', StickyHeader);

$( '.link-parent').each(function() {
  $(this).on("click", function(){
  $( this ).next().toggleClass( "open" );
  $( this ).toggleClass( "minus" );
});
});


$(function() {
  $( ".list-menu a" ).each(function() {


    if($(this).attr("href") == "/search") {
      console.log(  $(this))
      $(this).addClass('line-menu');
      $(this).text(''); 
 
   } 
  
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
  document.dispatchEvent(new 
CustomEvent("swym:collections-loaded"));

function swymCallbackFn(swat){
  // your API calls go here

  document.addEventListener("swym:collections-loaded", function(){
    swat.initializeActionButtons("<<Collections Grid PARENT Selector >>");
      

  })
}
if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

  } catch(e) { console.error(e); }
})();
})();
